import script from "./PankuzuHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PankuzuHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PankuzuHeader.vue?vue&type=style&index=0&id=15ea0e01&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15ea0e01"]])

export default __exports__